import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AppBar from 'material-ui/AppBar';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Mail from 'material-ui/svg-icons/communication/email';

class TopBar extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  setPage(page) {
    let isLocalhost = ((window.location||{}).href||'').includes('localhost');

    if (!isLocalhost)
      switch (page) {
        case '/':
          window.location.href = "http://www.jeffersonmolleri.com";
          return;
        case '/cerse':
          window.location.href = "http://cerse.org/";
          return;
      }
    this.context.router.history.push(page);
  }

  constructor(props) {
    super(props);
    this.state = {value: 1};
  }

  handleChange = (event, index, value) => this.setState({value});

  render() {
    return (
    <div>
      <AppBar
        title="jeffersonmolleri.com"
      />
      <Toolbar>
        <ToolbarGroup firstChild={true}>
          <FlatButton label="HOME" onClick={() => this.setPage('/')} />
		  <FlatButton label="PHD DISSERTATION" onClick={() => this.setPage('/thesis')} />
		  <FlatButton label="CERSE" onClick={() => this.setPage('/cerse')} />
        </ToolbarGroup>
      </Toolbar>
    </div>
    );
  }
}
export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js